import React from "react";
import Attachments from "../BasicInfo/Attachments";
import PropTypes from "prop-types";

const ConditionManufacturerAttachments = ({
  attachments,
  onAttachmentsUpdated,
}) => (
  <Attachments
    attachments={attachments}
    type={"condition_manufacturer"}
    onAttachmentsUpdated={onAttachmentsUpdated}
  />
);

ConditionManufacturerAttachments.propTypes = {
  attachments: PropTypes.array,
  onAttachmentsUpdated: PropTypes.func,
};

export default ConditionManufacturerAttachments;
